import * as React from "react";
import {resourcesHelper} from "@falcon/services";

interface IProps {
    wording: React.ReactNode;
}

export class WarningBanner extends React.Component<IProps> {

    public render(): React.ReactNode {
        return (
            <div className="banner">
                <img src={`/${resourcesHelper.THEME}/img/alert-blue.svg`} alt="Blue alert icon"/>
                <div className="banner-text">
                    {this.props.wording}
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/banners/WarningBanner.tsx